export default "__VITE_ASSET__BLjmOIC2__"